define('Components/EngagementsWidget/js/views/EngagementsWidgetInstanceView',['jquery','WidgetInstanceView','template!Components/EngagementsWidget/templates/default'],
    function($,WidgetInstanceView,defaultTemplate){
    return WidgetInstanceView.extend({
        name:'EngagementsWidgetInstanceView',
        events: {
            'click .expand':'expand'
        },
        getTemplate:function(){
            switch(this.model.getTemplate()){
                case 'default': default: return defaultTemplate; break;
            }
        },
        expand: function(e){
            this.$el.addClass('video-inactive');
        }
    })
});
